import React from 'react';
import { useParams } from 'react-router-dom';
import { useImageInspector } from './hooks';
import { ActionBar, MetadataDrawer, ImageDisplay, CollectionModal } from './components';
import { Box, Loader, Text } from '@mantine/core';
import { EventData } from '../../../types/Event';

// Constant for drawer width to avoid hardcoding
export const DRAWER_WIDTH = '380px';

interface ImageInspectorProps {
  onClose: () => void;
  imageUrl?: string; // For backward compatibility
  eventData?: EventData; // Optional event data if the image is part of an event
}

const ImageInspector: React.FC<ImageInspectorProps> = ({ onClose, eventData }) => {
  const { imageKey } = useParams();
  
  // Use custom hook to manage all state and logic
  const {
    metadata,
    loading,
    error,
    drawerState,
    formState,
    modalsState,
    saveFileName,
    saveEventDetails,
    saveLocationDetails,
    handleAddToCollection,
    handleCloseCollectionModal
  } = useImageInspector(imageKey, eventData);
  
  // Create a saveDatetime function since it's not provided by the hook
  const saveDatetime = () => {
    console.log('Saving datetime:', formState?.dateValue, formState?.timeValue);
    // In a real implementation, this would call an API to save the datetime
  };

  if (loading) {
    return (
      <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f8f9fa' }}>
        <Loader size="lg" color="blue" />
        <Text ml="md" fw={500}>Loading image metadata...</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f8f9fa' }}>
        <Text color="red" fw={500}>Error: {error}</Text>
      </Box>
    );
  }

  return (
    <>
      {/* Action Bar at the top */}
      <ActionBar 
        onClose={onClose} 
        metadata={metadata} 
        setActionBarHeight={drawerState.setActionBarHeight}
        drawerOpened={drawerState.opened}
        openDrawer={drawerState.open}
      />

      {/* Metadata Drawer */}
      {metadata && (
        <MetadataDrawer 
          metadata={metadata} 
          event={eventData}
          drawerState={drawerState}
          
        />
      )}

      {/* Main Image Display */}
      {metadata && (
        <ImageDisplay 
          metadata={metadata} 
          actionBarHeight={drawerState.actionBarHeight}
          drawerOpened={drawerState.opened}
          drawerWidth={DRAWER_WIDTH}
        />
      )}

      {/* Collection Modal */}
      <CollectionModal
        opened={modalsState.showAddCollectionModal}
        onClose={handleCloseCollectionModal}
        onAdd={handleAddToCollection}
        collections={modalsState.collections}
      />
    </>
  );
};

export default ImageInspector;
